export default __webpack_public_path__ + "static/media/save-icon.81994246.png";